import { useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL } from '../constants/urls';

const useCategoriesByLoyalty = (categorySlug) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!categorySlug) {
      setCategories([]);
      setLoading(false);
      return;
    }

    const fetchSlugs = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${BASE_URL}/coupon/slug-categories-by-loyalty`, {
          params: { categorySlug },
          headers: { Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}` }, 
        });
        setCategories(response.data || []);
      } catch (err) {
        setError(err.message || 'Erro ao buscar contagem');
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSlugs();
  }, [categorySlug]);

  return { categories, loading, error };
};

export default useCategoriesByLoyalty;
